<template>
  <div class="five columns"> 
    <div class="lotNumberContainer"> 
      <div class="lotNumber">
        Lot {{ podiumItem.display_lotnumber }}
      </div>
    </div>
    <h5>{{ podiumItem.lead }}</h5>
  </div>
</template>

<script>

export default {
	name: 'PhonePodium',
	data () {
		return {
		}
	},
	computed: {
		podiumItem: function () {
			return this.$store.getters.podium	
		}
	},
	mounted () {},
	methods: {
	}
}

</script>

<style scoped>

</style>
